import React from 'react';
import {SVG} from '../../../../../constants/assetLists';
import {ChatType} from './ChatBox';
import moment from 'moment';

type Props = {
  chat?: ChatType;
  value: string;
  disableTick?: boolean;
  disableDelete?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onTickClick: () => void;
  onDeleteClick: () => void;
};

function ChatInput({
  chat,
  value,
  disableTick,
  disableDelete,
  onChange,
  onTickClick,
  onDeleteClick,
}: Props) {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'; // reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // set to scroll height
    }
  }, [value]);

  return (
    <div className="w-full relative" onClick={e => e.stopPropagation()}>
      {chat && (
        <div className="flex items-center gap-2 absolute top-[10px] right-2 extraSmall:ml-[60px]">
          <div
            className={`w-[48px] h-[48px] rounded-full flex justify-center items-center`}
            style={{backgroundColor: '#1AC3F2'}}>
            <span className="text-[16px] font-normal text-black">
              {chat.commentBy?.firstName
                ?.split('')[0]
                ?.charAt(0)
                ?.toUpperCase() || 'U'}
              {chat.commentBy?.lastName
                ?.split('')[0]
                ?.charAt(0)
                ?.toUpperCase() || 'N'}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="text-black">
              {chat?.commentBy?.firstName || 'Unknown'}{' '}
              {chat?.commentBy?.lastName || 'User'} |{' '}
              {moment(chat.updatedAt).format('DD-MM-YYYY HH:mm')}
            </span>
          </div>
        </div>
      )}

      <textarea
        ref={textareaRef}
        placeholder="הוספת טקסט"
        className={`w-full rounded-[8px] border-1 border-gray50 pb-1 pl-[60px] pr-2 text-right focus:border-[#007AFF] outline-none resize-none
          ${chat ? 'pt-[70px]' : 'pt-1'}`}
        value={value}
        onChange={onChange}
      />

      <div className="absolute top-[5px] left-2 flex items-center gap-1">
        {/* Tick Icon */}
        <button
          type="button"
          className={`group/tick cursor-pointer w-8 h-8 flex justify-center items-center rounded-full transition-colors duration-300  ${
            disableTick ? 'opacity-40' : 'hover:bg-mintGreen'
          }`}
          disabled={disableTick}
          onClick={onTickClick}>
          <img
            src={SVG.tickIcon}
            alt="אישור"
            className={`w-[16px] h-[18px] object-contain ${
              !disableTick && 'group-hover/tick:hidden'
            }`}
          />

          <img
            src={SVG.tickGreenIcon}
            alt="אישור"
            className={`w-[16px] h-[18px] object-contain hidden ${
              !disableTick && 'group-hover/tick:block'
            }`}
          />
        </button>

        {/* Delete Icon */}
        <button
          type="button"
          className={`group/delete cursor-pointer w-8 h-8 flex justify-center items-center rounded-full ${
            disableDelete ? 'opacity-40' : 'hover:bg-[#fce8ee]'
          }`}
          disabled={disableDelete}
          onClick={onDeleteClick}>
          <img
            src={SVG.deleteIcon}
            alt="מחיקה"
            className={`w-[16px] h-[18px] object-contain ${
              !disableDelete && 'group-hover/delete:hidden'
            }`}
          />

          <img
            src={SVG.deleteRedIcon}
            alt="אישור"
            className={`w-[16px] h-[18px] object-contain hidden ${
              !disableDelete && 'group-hover/delete:block'
            } `}
          />
        </button>
      </div>
    </div>
  );
}

export default ChatInput;
